import { render } from "./Dossier.vue?vue&type=template&id=f3e7778e&scoped=true"
import script from "./Dossier.vue?vue&type=script&lang=js"
export * from "./Dossier.vue?vue&type=script&lang=js"

import "./Dossier.vue?vue&type=style&index=0&id=f3e7778e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3e7778e"]])

export default __exports__